__turbopack_context__.v({
  "container": "FilterTags-module-scss-module__zNsSEG__container",
  "filterTagsContainer": "FilterTags-module-scss-module__zNsSEG__filterTagsContainer",
  "padding36": "FilterTags-module-scss-module__zNsSEG__padding36",
});
